module.exports = {
  COOKIES: {
    EXPIRY: 7 * 4, // Days
    OTP_EXPIRY: 1, // Day
  },
};



// WEBPACK FOOTER //
// ./config/cookiesConfig.js